import  axios from 'axios'
export const fetchCustomers = async ({page, search, per_page, sort}) => {
    let currentPage = page || 1
    let perPage = per_page || 10
    let searchValue = search || ''
    let response
    try {
         response = await axios({
        method:'get',
        url:`/customers?page=${currentPage}&sort=${sort.value}&direction=${sort.direction}&per_page=${perPage}${searchValue? `&search=${searchValue}` : ''}`
    })}catch(e) {
        console.log(e)
    }

    return response.data
}
export const fetchCustomer = async (id, page = 1, sort) => {
    let response = await axios({
        method:'get',
        url:`/customers/${id}?page=${page}&sort=${sort.value}&direction=${sort.direction}&per_page=10`
    })
    return response.data
}
export const createCustomer = async (customer) => {
    let response = await axios({
        method:'post',
        url:`/customers`,
        data: customer
    })
    return response.data
}
export const editCustomer = async (customer) => {
    let response = await axios({
        method:'put',
        url:`/customers/${customer.id}`,
        data: customer
    })
    return response.data
} 

